import { memo } from "react";

const Input = ({ label, value, onChange, hasError }) => {
  return (
    <div className="relative min-w-max">
      <span
        className={[
          "absolute top-0 left-0 bg-white font-medium text-gray text-xs z-[1] whitespace-nowrap pe-4",
          hasError && "border-b border-b-red-error",
        ].join(" ")}
      >
        <span
          className={[
            "w-3 h-[22px] bg-gray-background absolute -right-0.5 rotate-45 top-0.5",
            hasError && "border-l border-l-red-error",
          ].join(" ")}
        />
        <span
          className={["relative bottom-1", hasError && "text-red-error"].join(
            " "
          )}
        >
          {label}
        </span>
      </span>
      <input
        className={[
          "px-2 pt-5 pb-[10px] bg-gray-background text-gray-dark_text font-medium rounded-lg outline-none w-full",
          hasError && "border border-red-error",
        ].join(" ")}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        dir="auto"
      />
    </div>
  );
};

export default memo(Input);
